$(document).ready(function () {
	$('.js-time-counter').each(function () {
		let timeCounterElement = this,
			$timeCounter = $(timeCounterElement);

		let baseCountInMinutes = $timeCounter.attr('data-base-count') ? parseInt($timeCounter.attr('data-base-count')) : 0,
			NumberToRaiseCountPerMinute = $timeCounter.attr('data-raise') ? parseInt($timeCounter.attr('data-raise')) : 14,
			startTime = $timeCounter.attr('data-stattime');

		// set start
		let currentDate = new Date();
		let startDate = new Date(startTime);
		let differenceOfDatesInMs = Math.abs(startDate - currentDate);
		let differenceOfDatesInMinutes = Math.floor((differenceOfDatesInMs / 1000) / 60);
		let todayInMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();

		let count = baseCountInMinutes + differenceOfDatesInMinutes + todayInMinutes;

		$timeCounter.attr('data-count', count);

		// init counter
		var options = {
			useEasing: true,
			useGrouping: true,
			separator: '.',
			decimal: ',',
			prefix: '',
			suffix: '',
			enableScrollSpy: true
		};

		let CountUpCounter = new CountUp(timeCounterElement, count, options);

		// handle count up
		let timeoutInMS = 60000;
		let timerInterval = setInterval(handleInterval, timeoutInMS);

		function handleInterval() {
			let currentCount = $timeCounter.attr('data-count') ? parseInt($timeCounter.attr('data-count')) : 0;
			let newStartCount = currentCount + NumberToRaiseCountPerMinute;
			$timeCounter.attr('data-count', newStartCount);
			CountUpCounter.update(newStartCount);
		}

	});
});
